module.exports = __webpack_public_path__ + "img/banner-bg-cplis.0a87b328.jpg";